import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../../api';
import { inject } from '@angular/core';
import { CurafidaAuthService } from '../../../authentication/curafida-auth.service';
import { CurafidaSession } from '../../../authentication/curafida-session';
import { tap } from 'rxjs/operators';
import { LoggingService } from '../../../logging/logging.service';
import { isBackendRequest } from './is-backend-request';

export function AuthInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const log = inject(LoggingService).getLogger('AuthInterceptor');

    if (isBackendRequest(request.url)) {
        const curafidaAuthService = inject(CurafidaAuthService);
        const session = curafidaAuthService?.getSession();

        const isAuthenticated = curafidaAuthService.isAuthenticated();
        if (isAuthenticated && session?.backendUrl) {
            // fetch token
            const token = session.tokenSet.access_token;
            // Add Token and header options

            const authReq = request.clone({
                url: replaceUrl(request.url, session),
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json',
                    contentType: 'application/json',
                },
                withCredentials: true,
            });

            return next(authReq).pipe(
                tap((event) => {
                    if (event.type === HttpEventType.Response && event.status === 401) {
                        log.debug(authReq.url, 'returned a response with status', event.body);
                    }
                }),
            );
        } else {
            return next(request).pipe(
                tap((event) => {
                    if (event.type === HttpEventType.Response && event.status === 401) {
                        log.debug(request.url, 'returned a response with status', event.body);
                    }
                }),
            );
        }
    }
    return next(request).pipe(
        tap((event) => {
            if (event.type === HttpEventType.Response && event.status === 401) {
                log.debug(request.url, 'returned a response with status', event.body);
            }
        }),
    );
}

function replaceUrl(url: string, session: CurafidaSession) {
    if (url.includes(ApiService.defaultUrl)) {
        url = url.replace(ApiService.defaultUrl, '');
    }
    return url.includes('http') ? url : session.backendUrl + url;
}
